var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{attrs:{"group":"auth","position":"top center "}}),_c('notifications',{attrs:{"group":"info","position":"top center"}}),_c('dialogs-wrapper',{attrs:{"wrapper-name":"default"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }